import { IGlobalNavigationItem } from '@components/Layouts/Layout/Layout';
import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import React, { useContext } from 'react';

import { ArrowRight } from '../Icon';
import * as styles from './NavigationPanel.module.css';

const NavigationPanel = ({
	subMenus,
	accordionOpen,
	socket,
}: {
	subMenus: IGlobalNavigationItem[];
	accordionOpen: boolean;
	socket?: boolean;
}) => {
	const { variant } = useContext(ThemeContext);

	return (
		<div
			className={cx(styles.accordionPanel, styles[variant], {
				[styles.socket]: socket,
			})}
			aria-hidden={accordionOpen ? 'false' : 'true'}
		>
			<nav className={styles.accordionPanelLayout}>
				{subMenus.map(({ label, to, menu }, key: number) => (
					<div className={styles.menuArea} key={key}>
						<a
							href={to}
							className={cx(styles.link, styles.lead, styles.bright)}
							aria-hidden={accordionOpen ? 'false' : 'true'}
							tabIndex={accordionOpen ? 0 : -1}
						>
							{label}
							<div className={styles.arrow}>
								<ArrowRight />
							</div>
						</a>

						<ul className={cx(styles.list, styles.stretch)}>
							{menu.map(
								({ label, menu }: { label: string; menu: [] }, key: number) => (
									<li key={key}>
										<h5 className={styles.heading}>{label}</h5>

										{menu && (
											<ul className={cx(styles.list, styles.space)}>
												{menu.map(({ to, label, tag }, key) => (
													<li key={key}>
														<a
															href={to}
															className={cx(
																styles.link,
																styles.accordion,
																styles.bright
															)}
															aria-hidden={accordionOpen ? 'false' : 'true'}
															tabIndex={accordionOpen ? 0 : -1}
														>
															<div className={styles.content}>
																{label}
																{tag && (
																	<span className={styles.tag}>{tag}</span>
																)}
															</div>

															<div className={styles.arrow}>
																<ArrowRight />
															</div>
														</a>
													</li>
												))}
											</ul>
										)}
									</li>
								)
							)}
						</ul>
					</div>
				))}
			</nav>
		</div>
	);
};

export default NavigationPanel;
